import { SwitchField } from '@dev-spendesk/grapes';

import { useFeature } from 'src/core/common/hooks/useFeature';
import { useTranslation } from 'src/core/common/hooks/useTranslation';
import FEATURES from 'src/core/constants/features';
import { useDisableFeature } from 'src/core/modules/company/general-settings/components/SpendingMethods/hooks/useDisableFeature';
import { useEnableFeature } from 'src/core/modules/company/general-settings/components/SpendingMethods/hooks/useEnableFeature';

export const ExportCurrencyField = () => {
  const { t } = useTranslation('global');
  const cardExchangeRate = useFeature(FEATURES.NETSUITE_CARD_EXCHANGE_RATE);
  const invoiceExpenseClaimsExchangeRate = useFeature(
    FEATURES.NETSUITE_INVOICE_EXPENSE_CLAIMS_EXCHANGE_RATE,
  );

  const [disableCardExchangeRate] = useDisableFeature(
    FEATURES.NETSUITE_CARD_EXCHANGE_RATE,
  );
  const [disableInvoiceExpenseClaimsExchangeRate] = useDisableFeature(
    FEATURES.NETSUITE_INVOICE_EXPENSE_CLAIMS_EXCHANGE_RATE,
  );

  const [enableFeature] = useEnableFeature();

  const handleCardExchangeRate = async () => {
    if (cardExchangeRate) {
      await disableCardExchangeRate();
      return;
    }

    await enableFeature({ featureCode: FEATURES.NETSUITE_CARD_EXCHANGE_RATE });
  };

  const handleInvoiceExpenseClaims = async () => {
    if (invoiceExpenseClaimsExchangeRate) {
      await disableInvoiceExpenseClaimsExchangeRate();
      return;
    }

    await enableFeature({
      featureCode: FEATURES.NETSUITE_INVOICE_EXPENSE_CLAIMS_EXCHANGE_RATE,
    });
  };

  return (
    <>
      <div className="separator" />
      <p className="heading-l">
        {t('bookkeep.integrations.settings.exchangeCurrency.title')}
      </p>
      <SwitchField
        fit="parent"
        label={t(
          'bookkeep.integrations.settings.exchangeCurrency.invoiceToggleTitle',
        )}
        helpText={t(
          'bookkeep.integrations.settings.exchangeCurrency.invoiceToggleDescription',
        )}
        isChecked={invoiceExpenseClaimsExchangeRate}
        onChange={() => handleInvoiceExpenseClaims()}
      />
      <SwitchField
        label={t(
          'bookkeep.integrations.settings.exchangeCurrency.cardToggleTitle',
        )}
        helpText={t(
          'bookkeep.integrations.settings.exchangeCurrency.cardToggleDescription',
        )}
        isChecked={cardExchangeRate}
        onChange={() => handleCardExchangeRate()}
        fit="parent"
      />
    </>
  );
};
